import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const DocsConfigContext = createContext(null);

export const DocsConfigProvider = ({ children }) => {
  const defaultBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
  const [baseUrl, setBaseUrl] = useState(defaultBaseUrl);
  const [apiKey, setApiKey] = useState('');

  useEffect(() => {
    const savedApiKey = localStorage.getItem('api_key') || '';
    const savedBaseUrl = localStorage.getItem('api_base_url') || defaultBaseUrl;
    setApiKey(savedApiKey);
    setBaseUrl(savedBaseUrl);
  }, []);

  const updateApiKey = (value) => {
    setApiKey(value);
    if (value) localStorage.setItem('api_key', value);
    else localStorage.removeItem('api_key');
  };

  const updateBaseUrl = (value) => {
    setBaseUrl(value);
    if (value) localStorage.setItem('api_base_url', value);
    else localStorage.removeItem('api_base_url');
  };

  const value = useMemo(() => ({ baseUrl, apiKey, setApiKey: updateApiKey, setBaseUrl: updateBaseUrl }), [baseUrl, apiKey]);

  return (
    <DocsConfigContext.Provider value={value}>
      {children}
    </DocsConfigContext.Provider>
  );
};

export const useDocsConfig = () => {
  const ctx = useContext(DocsConfigContext);
  if (!ctx) throw new Error('useDocsConfig must be used within DocsConfigProvider');
  return ctx;
};
